import React from "react";

import styles from "./CustomSmallInputField.module.css"
import {SubtractionType} from "../../../api/generated";

interface CustomSmallInputFieldProps {
    type?: any
    value?: any
    readOnly?: boolean
    disabled?: boolean
    placeholder?: string
    setValue: (value: any) => void
    subtractionType?: SubtractionType
    errorMessage?: string
}


export const CustomSmallInputField: React.FC<CustomSmallInputFieldProps> = ({
                                                                                type,
                                                                                value,
                                                                                readOnly,
                                                                                disabled,
                                                                                setValue,
                                                                                placeholder,
                                                                                subtractionType,
                                                                                errorMessage
                                                                            }) => {

    const getInputStyle = () => {
        if (subtractionType) {
            return subtractionType === SubtractionType.Number ? styles.inputNumber : styles.inputPercentage
        } else {
            return styles.input
        }
    }

    return <div className={styles.wrapper}>
        <div className={styles.inputWrapper}>
            <input
                type={type}
                value={(!!value || value === 0) ? value : ""}
                readOnly={readOnly}
                disabled={disabled}
                placeholder={placeholder}
                onChange={e => setValue(e.target.value)}
                onWheel={(e) => e.currentTarget.blur()}
                className={`${getInputStyle()} ${errorMessage && styles.inputError}`}
            />
            {subtractionType === SubtractionType.Number && <span className={styles.number}>£</span>}
            {subtractionType === SubtractionType.Percentage && <span className={styles.percentage}>%</span>}
        </div>
        <div style={{visibility: `${!errorMessage ? "hidden" : "visible"}`}} className={styles.errorWrapper}>
            <img src={"/alertIcon.svg"} alt={"alert icon"}/>
            <span className={styles.errorMessage}>{errorMessage}</span>
        </div>
    </div>
}
